import { render, staticRenderFns } from "./ReinscripcionConfirmacion.vue?vue&type=template&id=213e2640&"
import script from "./ReinscripcionConfirmacion.vue?vue&type=script&lang=js&"
export * from "./ReinscripcionConfirmacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports